import * as React from "react";
import { useState, useEffect, useMemo } from "react";
import { RowTitleButton } from "common/components";
import { useModalContext } from "common/contexts";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import StepActionsButton from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
import DescriptionCell from "../DescriptionCell";
const TitleCell = ({ eventProcedureStep }) => {
  const [selectedStepId, setSelectedStepId] = useState(void 0);
  const { setModal, setEntity } = useModalContext();
  const onClickStep = () => {
    setSelectedStepId(eventProcedureStep.id);
    setEntity(eventProcedureStep);
    setModal("EDIT-EVENT-PROCEDURE-STEP");
  };
  useEffect(() => {
    if (eventProcedureStep.id === selectedStepId) setEntity(eventProcedureStep);
  }, [eventProcedureStep, selectedStepId, setEntity]);
  return /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: onClickStep }, (eventProcedureStep == null ? void 0 : eventProcedureStep.title) || "No title set");
};
export const useColumnRenderers = () => {
  const { pluggableColumnRenderers } = usePluggableEntityTableElements(
    null,
    "event_procedure_step"
  );
  const columnRenderers = useMemo(
    () => ({
      attributes: {
        title: {
          renderCell: (_, eventProcedureStep) => /* @__PURE__ */ React.createElement(TitleCell, { eventProcedureStep })
        },
        description: {
          renderCell: (_, step) => /* @__PURE__ */ React.createElement(DescriptionCell, { mdValue: step.description })
        },
        type: {
          renderCell: (_, step) => /* @__PURE__ */ React.createElement(StepActionsButton, { step }),
          staticWidth: 140
        },
        ...pluggableColumnRenderers
      }
    }),
    [pluggableColumnRenderers]
  );
  return { columnRenderers };
};
